export const METRIC_TYPES = {
  NET_SALES: 'NS',
  CHECK_COUNTS: 'CC',
  AVERAGE_CHECK: 'AC',
  OVERTIME: 'OT',
  SPLH: 'SPLH',
  LABOR: 'LABOR',
  HOURS: 'HOURS'
}